// pages/Dashboard.jsx
import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Admin Dashboard</h1>
        <p style={styles.subtitle}>Welcome to the admin panel.</p>
        <button onClick={handleLogout} style={styles.logoutButton}>
          Logout
        </button>
      </div>

      <div style={styles.sectionContainer}>
        <div style={styles.card} onClick={() => navigate('/users')}>👥 Manage Users</div>
        <div style={styles.card} onClick={() => navigate('/broadcast')}>📣 Broadcast Notifications</div>
        <div style={styles.card} onClick={() => navigate('/credit-admin')}>💳 Credit Admin</div>
        <div style={styles.card} onClick={() => navigate('/student-verification')}>🎓 Student Verifications</div>
        <div style={styles.card} onClick={() => navigate('/identity-verification')}>🪪 Identity Verification</div>
        <div style={styles.card} onClick={() => navigate('/admin/payouts')}>🧾 Admin Payouts</div>
        <div style={styles.card} onClick={() => navigate('/bookings')}>📦 View Bookings</div>
        <div style={styles.card} onClick={() => navigate('/listinglogs')}>📝 Listing Admin Logs</div>
        <div style={styles.card} onClick={() => navigate('/export')}>📄 Export CSV</div>
        <div style={styles.card} onClick={() => navigate('/receipts')}>💳 Stripe Receipts</div>
        <div style={styles.card} onClick={() => navigate('/suspend')}>🚫 Block / Suspend</div>
        <div style={styles.card} onClick={() => navigate('/upgrade')}>⭐ Upgrade Tier</div>
        <div style={styles.card} onClick={() => navigate('/logs')}>📜 View Logs</div>
        <div style={styles.card} onClick={() => navigate('/admin/reports')}>🛡️ View Reports</div>
        <div style={styles.card} onClick={() => navigate('/condition-reports')}>📷 Condition Reports</div>
        <div style={styles.card} onClick={() => navigate('/admin/bank-approvals')}>🏦 Bank Approvals</div>
        <div style={styles.card} onClick={() => navigate('/refund-tool')}>💸 Refund Tool</div>
        <div style={styles.card} onClick={() => navigate('/admin/deposits')}>🧰 Admin • Deposits</div>
        <div style={styles.card} onClick={() => navigate('/finance-dashboard')}>📊 Finance Dashboard</div>
        <div style={styles.card} onClick={() => navigate('/consents')}>🧾 Consent Logs</div>
        <div style={styles.card} onClick={() => navigate('/guideline-logs')}>📘 Rental Guidelines</div>

        {/* NEW: Referrals Admin */}
        <div style={styles.card} onClick={() => navigate('/referrals')}>🎯 Referrals Admin</div>
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '2rem', fontFamily: 'system-ui, sans-serif', backgroundColor: '#f9f9f9', minHeight: '100vh' },
  header: { textAlign: 'center', marginBottom: '2rem' },
  title: { fontSize: '2rem', marginBottom: '0.5rem', color: '#065f46' },
  subtitle: { fontSize: '1rem', color: '#555', marginBottom: '1rem' },
  logoutButton: { backgroundColor: '#d32f2f', color: 'white', padding: '0.5rem 1rem', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' },
  sectionContainer: { display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem' },
  card: {
    width: '180px', height: '120px', backgroundColor: '#e0f2f1', borderRadius: '10px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center',
    padding: '0 12px', fontWeight: '500', fontSize: '1rem', boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    cursor: 'pointer', transition: 'transform 0.2s ease',
  },
};
